// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"LoaderCircle_text-gradient__1keYq","loader":"LoaderCircle_loader__cWUuH"};